import { render } from "./otpActive.vue?vue&type=template&id=2cf230d1"
import script from "./otpActive.vue?vue&type=script&lang=js"
export * from "./otpActive.vue?vue&type=script&lang=js"

import "./otpActive.vue?vue&type=style&index=0&id=2cf230d1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__